import {ButtonProps} from './types'
import ButtonView from './ButtonView'
import React from 'react'

const Button = (props: ButtonProps): React.ReactElement => {
    const {
        type = 'button',
        focus,
        onPress,
        ...rest
    } = props

    const buttonRef = React.useRef<HTMLButtonElement>(null)
    const handlePress = (event?: React.MouseEvent<HTMLButtonElement>) => {
        if (onPress) {
            onPress(event)
        }
    }

    React.useLayoutEffect(() => {
        if (focus) {
            buttonRef.current?.focus()
        }
    }, [focus])

    return <ButtonView ref={buttonRef} type={type} {...rest} onPress={handlePress} />
}

export default Button
